export const REQUEST_LINKED_ACCOUNTS = 'REQUEST_LINKED_ACCOUNTS';
export const RECEIVE_LINKED_ACCOUNTS = 'RECEIVE_LINKED_ACCOUNTS';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export class UpdateUser {
    constructor(user) {
        this.type = UPDATE_USER;
        this.payload = user;
    }
}
export class UpdateUserProfile {
    constructor(userProfile) {
        this.type = UPDATE_USER_PROFILE;
        this.payload = userProfile;
    }
}
export class RequestLinkedAccounts {
    constructor() {
        this.type = REQUEST_LINKED_ACCOUNTS;
    }
}
export class ReceiveLinkedAccounts {
    constructor(linkedAccounts) {
        this.linkedAccounts = linkedAccounts;
        this.type = RECEIVE_LINKED_ACCOUNTS;
    }
}
